import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionInstructions from '../components/ActionInstructions';

export const ActionIntroPage = () => {
    return (
        <ActionInstructions />
    );
}